var map = {
	"./上海/官网/2.jpg": 22134,
	"./北京/官网/2.jpg": 19036,
	"./南京/官网/2.jpg": 24492,
	"./广州/官网/2.jpg": 19714,
	"./成都/官网/2.jpg": 50282,
	"./杭州/官网/2.jpg": 46714,
	"./武汉/官网/2.jpg": 8583,
	"./深圳/官网/2.jpg": 3506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49422;